// extracted by mini-css-extract-plugin
export default {"Container":"BanksComponet_Container__hrjtd","data":"BanksComponet_data__gMtEe","dataItem":"BanksComponet_dataItem__kuGHG"};